import { message } from "antd";
import { useEventAction } from "../contexts/EventContext";

const GlobalMessage = () => {
    const [messageApi, contextHolder] = message.useMessage();

    useEventAction("global-message", (event) => {
        const { type, content, ...options } = event.payload;

        messageApi.open({
            type: type || "info",
            content: content,
            ...options
        });
    });

    return contextHolder;
}

export default GlobalMessage;
